import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiClient } from '../../apiClient';
import { writeAuditLog } from '../../lib/auditLogger';

const CsvJobDetail = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        const jobResponse = await apiClient.get(`/admin/csv-jobs/${id}`);
        const jobData = await jobResponse.json();
        setJob(jobData);

        const errorsResponse = await apiClient.get(`/admin/csv-jobs/${id}/errors`);
        const errorsData = await errorsResponse.json();
        setErrors(errorsData);

        // Record Audit Log: CSVJOB_VIEW
        writeAuditLog({
          action: 'CSVJOB_VIEW',
          resourceType: 'csv_job',
          resourceId: id,
          metadata: { source: 'admin_console' }
        });
      } catch (error) {
        console.error('ジョブ詳細の取得中にエラーが発生しました:', error);
      }
    };

    fetchJobDetails();
  }, [id]);

  if (!job) {
    return <div>読み込み中...</div>;
  }

  return (
    <div className="bg-white p-8 rounded-lg shadow-sm">
      <h2 className="text-2xl font-bold mb-6">CSV処理詳細</h2>
      <div className="grid grid-cols-2 gap-4 text-sm mb-6">
        <p><strong>実行日時:</strong> {new Date(job.created_at.seconds * 1000).toLocaleString()}</p>
        <p><strong>CSVファイル名:</strong> {job.original_file_name}</p>
        <p><strong>CSV種類:</strong> {job.type}</p>
        <p><strong>テナントID:</strong> {job.tenant_id}</p>
        <p><strong>実行ユーザー:</strong> {job.user_id}</p>
        <p><strong>総件数:</strong> {job.total_rows}</p>
        <p><strong>成功件数:</strong> {job.success_count}</p>
        <p><strong>失敗件数:</strong> {job.error_count}</p>
        <p><strong>ステータス:</strong>
          <span className={`ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${job.status === 'completed' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {job.status === 'completed' ? '完了' : '失敗'}
          </span>
        </p>
      </div>

      <h3 className="text-xl font-bold mb-4">エラー一覧</h3>
      <div className="overflow-x-auto border rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">行番号</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">エラーコード</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">エラーメッセージ</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {errors.length > 0 ? errors.map(error => (
              <tr key={error.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{error.error_row}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{error.error_code}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{error.error_message}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="3" className="px-6 py-4 text-center text-sm text-gray-500">エラーはありません</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CsvJobDetail;
